//https://material-ui-next.com/demos/dialogs/
import React from "react";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Snackbar from "@material-ui/core/Snackbar";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";
import InputWithIcon from "./InputWithIcon";
import IconButton from "@material-ui/core/IconButton";
import share from "../../icons/forward-arrow.png";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import classNames from "classnames";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import { Modal, Button } from "antd";
import capsule from "../../icons/capsule.jpg";
import "./senddialog.css";

const printPillsSelected = (cards) => {
  var arrlength = cards.length;
  var list = [];
  for (var i = 0; i < arrlength; i++){
    list.push(
      <div className="selectedpills">
        {cards[i].Med_Name_Generic}
      </div>
    );
  }
  return list;
}

export default class SendDialog extends React.Component {
  state = {
    modal1Visible: false
  };

  setModal1Visible(modal1Visible) {
    this.setState({ modal1Visible });
  }

  // todo-- add alert when pill cards are sent

  constructor(props) {
    super(props);
    this.handleAlertOpen = this.handleAlertOpen.bind(this);
    this.handleAlertClose = this.handleAlertClose.bind(this);
    this.state = {
      alert: false,
      variant: "success",
      message:
        "Pill cards sent! You will receive them within the next 15 minutes."
    };
  }

  handleAlertOpen = (variant, message) => {
    this.setState({ alert: true, variant, message });
  };

  handleAlertClose = () => {
    this.setState({ alert: false });
  };

  render() {
    return (
      <div className="button-div">
        {this.props.switchOption ? "" : (
          <button onClick={() => this.setModal1Visible(true)}>
            <img className="appbar-button" src={share} alt="share" height="35px" />
            <div>Send Info</div>
          </button>
        )} 
        <Modal
          title="Share Pill Cards"
          centered
          closable={false}
          visible={this.state.modal1Visible}
          onCancel={() => this.setModal1Visible(false)}
          onOk={() => this.setModal1Visible(false)}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => this.setModal1Visible(false)}
            >
              DONE
            </Button>
          ]}
        >
          <Snackbar
            open={this.state.alert}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={5000}
            className="dialog-snackbar"
            onClose={this.handleAlertClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleAlertClose}
              variant={this.state.variant}
              message={this.state.message}
            />
          </Snackbar>
          <div className="dialog-instructions">
            <p>To send a one-time snapshot of your pill notes to your patient, either type in his/her phone number or email address.</p>

            <p>Email and text will be sent from pillnotes.com not the doctor's email. </p>
            <p className="share-text3">No patient data will be shared. Your future customizations will not be reflected in past snapshots. Please send a new snapshot if there are edits.</p> 
          </div>
          
          <div className="capsule">
            <img className="img-capsule" src={capsule} />
          </div>

          <div className="selected-pills">
            <p> {`Pills selected:`} </p>
            {printPillsSelected(
              this.props.cards
            )}
          </div>

          <InputWithIcon
            type="Email"
            url={this.props.url}
            changes={this.props.changes}
            confirmHandler={this.handleAlertOpen}
          />
          <div className="dialog-margin"/>
          <InputWithIcon
            type="Text"
            url={this.props.url}
            changes={this.props.changes}
            confirmHandler={this.handleAlertOpen}
          />
        </Modal>
      </div>
    );
  }
}

//taken from the material-ui demo: https://codesandbox.io/s/jjy3nnkrr9
const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);



// WEBPACK FOOTER //
// ./src/NavBar/SendDialog/index.js